import React from "react";
import * as c from "./ctaButton.module.scss";
import classNames from "classnames";
import { Button } from "@components/shared";
import IconArrowRight from "@icons/iconArrowRight";
import { trackEvent } from "@utils/analytics";
import chat from "@utils/chat";

export default function CtaButton({
  className,
  label,
  url,
  style,
  isExternal = null,
  showIcon = null,
  iconVersion = "v1",
  trackedEventName = null,
  size = "medium",
  openChat = false,
}) {
  if (!url || !label) {
    return null;
  }

  const onClickHandler = (e) => {
    if (trackedEventName) {
      trackEvent(trackedEventName);
    }

    if (openChat) {
      e.preventDefault();
      chat.open();
    }
  };

  const styleMap = {
    "Button Primary": "full",
    "Button Secondary": "outline",
    Link: "link",
  };

  const buttonStyle = styleMap[style];

  return (
    <Button
      className={classNames(className, c.button, c[buttonStyle], { [c.hasIcon]: showIcon })}
      linkTo={url}
      size={size}
      variant={buttonStyle}
      isExternal={isExternal}
      onClick={onClickHandler}
      asHtmlButton={openChat}
    >
      {label}
      {showIcon && <IconArrowRight className={classNames(c.arrowIcon, c[iconVersion])} version={iconVersion} />}
    </Button>
  );
}
